// Keep bundle choices aligned with the variant resolved by Shopify's picker.
class CoreyOrderFields extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.generation = 0;
    const scope = this.closest('.shopify-section, dialog, product-card');
    const form = this.closest('form');
    const options = { signal: this.controller.signal };
    scope?.addEventListener('shopify:product:select', this.onProductSelect, options);
    form?.addEventListener('change', this.onFormChange, options);
    this.sync(form?.querySelector('[name="id"]')?.value);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.generation++;
  }

  onFormChange = () => {
    this.sync(this.closest('form')?.querySelector('[name="id"]')?.value);
  };

  onProductSelect = async (event) => {
    if (event.target?.closest('product-card') && !event.target.closest('product-card').contains(this)) return;
    const generation = ++this.generation;
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || generation !== this.generation || !detail) return;
      if (detail.productId && String(detail.productId) !== this.dataset.productId) return;
      this.sync(detail.resource?.id);
    } catch {
      // An interrupted selection is superseded by the next picker event.
    }
  };

  sync(variantId) {
    if (!variantId) return;
    const expanded = (this.dataset.expandedVariantIds || '').split(',').includes(String(variantId));
    this.querySelectorAll('[data-extra-option]').forEach((group) => {
      group.hidden = !expanded;
      group.querySelectorAll('select').forEach((field) => {
        field.disabled = !expanded;
        field.required = expanded;
        field.setAttribute('aria-required', String(expanded));
        if (!expanded) field.value = '';
      });
    });
  }
}

if (!customElements.get('corey-order-fields')) {
  customElements.define('corey-order-fields', CoreyOrderFields);
}
